export enum Visibility {
  DRAFT = 'draft',
  PUBLIC = 'public',
  SCHEDULED = 'scheduled',
  ARCHIVED = 'archived',
}

export interface BlogSharingOptions {
  facebook: boolean
  instagram: boolean
  tiktok: boolean
  X: boolean
  youtube: boolean
  linkedIn: boolean
}

export interface BlogPayloadType {
  title: string
  featureImageId: string
  content: string
  readingTime?: number
  authorIds: string[]
  organizationId: string
  visibility: Visibility
  sharingOptions: BlogSharingOptions
  excerpt?: string
  scheduledAt?: string
}
